module.exports = __webpack_public_path__ + "static/media/format_align_left-24px.baba9415.svg";